import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons.svg'
import _imports_1 from '../assets/market.png'


const _withScopeId = n => (_pushScopeId("data-v-14fabf3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + '#icon-chevron-right'
const _hoisted_2 = { class: "halal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "halal-heading" }, "withHalal financial access is easy for all", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "halal-para" }, " There is a representation for everyone in the society provided in Halal, no one is left unbanked ", -1))
const _hoisted_5 = { class: "halal-top d-flex flex-column flex-md-row justify-content-between" }
const _hoisted_6 = { class: "d-grid halal-top-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-decoration-none d-block"
}, [
  /*#__PURE__*/_createTextVNode("Learn More "),
  /*#__PURE__*/_createElementVNode("svg", null, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": _hoisted_1 })
  ])
], -1))
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"halal-btm d-flex flex-column flex-md-row align-items-center\" data-v-14fabf3a><div class=\"halal-btm-1\" data-v-14fabf3a><img src=\"" + _imports_1 + "\" alt=\"market\" class=\"w-100 h-100\" data-v-14fabf3a></div><div class=\"halal-btm-2\" data-v-14fabf3a><h2 data-v-14fabf3a> Join other small business owners growing their business with WithHalal </h2><p data-v-14fabf3a> “withHalal, you can access zero-interest loan in 5 minutes when you setup your business profile and use our product offers in short period.” </p><a style=\"font-style:italic;\" class=\"text-decoration-none text-end d-block\" data-v-14fabf3a>CEO, Halal </a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_2, [
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supports, (support) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "halal-support",
          key: support.heading
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(support.heading), 1),
              _createElementVNode("p", null, _toDisplayString(support.paragraph), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(["halal-top-img", `halal-top-img-${support.img}`])
              }, [
                _createElementVNode("img", {
                  src: require(`@/assets/support${support.img}.png`),
                  alt: "support",
                  class: "w-100 h-100"
                }, null, 8, _hoisted_8)
              ], 2)
            ])
          ])
        ]))
      }), 128))
    ]),
    _hoisted_9
  ]))
}